import { render, staticRenderFns } from "./MultipleChoiceOption.vue?vue&type=template&id=d61f8264&"
import script from "./MultipleChoiceOption.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceOption.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceOption.vue?vue&type=style&index=0&id=d61f8264&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports